import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const PublicRoute: React.FC = () => {
  const { isAuthenticated, loginType } = useAuth();

  if (isAuthenticated && loginType !== 'token') {
    return <Navigate to={'/customer/claims'} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;